/** @type {string[]|null} */
let domains = null;
/** @type {Promise<void>|null} */
let loadPromise = null;

/**
 * Preload blocked domain names for synchronous checks before window.open.
 * @returns {Promise<void>}
 */
export function ensureLoaded() {
  if (domains) {
    return loadPromise || Promise.resolve();
  }
  if (!loadPromise) {
    loadPromise = fetch('/api/blocked-domains')
      .then((res) => (res.ok ? res.json() : { domains: [] }))
      .then((json) => {
        domains = Array.isArray(json.domains) ? json.domains : [];
      })
      .catch(() => {
        domains = [];
      });
  }
  return loadPromise;
}

/**
 * Reset cache (for tests).
 */
export function resetBlocklistCache() {
  domains = null;
  loadPromise = null;
}

/**
 * @param {string} hostname
 * @param {string[]} blockedDomains
 * @returns {boolean}
 */
export function isHostnameBlockedByList(hostname, blockedDomains) {
  if (!hostname || !blockedDomains?.length) {
    return false;
  }
  const host = hostname.toLowerCase();
  for (const blocked of blockedDomains) {
    const domain = String(blocked || '').toLowerCase();
    if (!domain) continue;
    if (host === domain || host.endsWith('.' + domain)) {
      return true;
    }
  }
  return false;
}

/**
 * @param {string} hostname
 * @returns {boolean}
 */
export function isHostnameBlocked(hostname) {
  return isHostnameBlockedByList(hostname, domains || []);
}

/**
 * @param {string} url
 * @returns {boolean}
 */
export function isUrlBlocked(url) {
  try {
    return isHostnameBlocked(new URL(url).hostname);
  } catch {
    return true;
  }
}
